module.exports = __webpack_public_path__ + "static/img/2_3.e06d5b97.jpg";